import PropTypes from "prop-types";
import styled from "@emotion/styled";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "@mui/material";

import FaceContainer from "../FaceContainer";

const StyledAddFacesButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(-45deg, #517BD3 0, #79BBF7 100%)",
  cursor: "pointer",
  border: "none",
  color: "white",
  width: 50,
  height: 50,
  borderRadius: "50%",
  "&:hover": {
    transform: "scale(1.1)",
  },
  [theme.breakpoints.up("mobile")]: {
    width: 75,
    height: 75,
  },
}));

const StyledAddIcon = styled(AddIcon)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(32),
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.pxToRem(48),
  },
}));

const AddFacesButton = ({ onAddFace }) => {
  return (
    <FaceContainer data-testid="add-face-button">
      <StyledAddFacesButton
        onClick={() => {
          onAddFace();
        }}
      >
        <StyledAddIcon />
      </StyledAddFacesButton>
      <Typography component="label" variant="caption" mt={1}>
        Add photo
      </Typography>
    </FaceContainer>
  );
};

AddFacesButton.propTypes = {
  onAddFace: PropTypes.func.isRequired,
};

export default AddFacesButton;
